import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 12h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 18V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 12 3-2v8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Heading1";
const Heading1 = memo(themed(Icon));
export {
  Heading1
};
//# sourceMappingURL=heading-1.js.map
